<template>
  <div>
    <header class="bg-grey-6">
      <SGPRowComponent>
        <SGPColComponent cols="11">
          <router-link to="/">
            <img src="https://mondrian.claro.com.br/brands/horizontal/inverse/claro.svg" />
          </router-link>
        </SGPColComponent>
        <SGPColComponent cols="1" style="text-align: right;">
          <v-menu
            open-on-hover
            bottom
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <button
                v-bind="attrs"
                v-on="on"
              >
                <SGPIconComponent large class="btn-portal-header" color="white" icon="mdi-help-circle"></SGPIconComponent>
              </button>
            </template>
            <v-list dense>
              <v-list-item  class="cursor-pointer" to="//apps.powerapps.com/play/e/default-55247d4b-b435-47a5-881b-ca7627434e79/a/53cfb538-c10e-4ad9-b70a-96395f3e78af?tenantId=55247d4b-b435-47a5-881b-ca7627434e79&source=sharebutton&sourcetime=1706904832090" target="_blank" @click="portalSolicitacoes">
                <v-list-item-content>
                  <v-list-item-title>Portal de Solicitações</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item  class="cursor-pointer">
                <v-list-item-content>
                  <v-list-item-title>
                    <router-link class="link-documentos-processos" to="//corpclarobr.sharepoint.com/sites/USER-Comunicao-InstalaoEmpresarial/Documentos%20Compartilhados/Forms/AllItems.aspx" target="_blank">
                        Documentos de processos
                    </router-link>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </SGPColComponent>
      </SGPRowComponent>
    </header>

    <section class="login-body">
      <div class="container">
        <div
          class="d-flex justify-content-center align-items-center"
          style="min-height: 150px"
        >
          <FormLoginComponent />
        </div>
      </div>
    </section>

    <!-- <footer class="mdn-Footer mdn-Footer--simple mdn-Footer--signature">
      <div class="mdn-Container">
        <div class="mdn-Footer-content">
          <div class="mdn-Footer-disclaimer">
            <p class="mdn-Text mdn-Text--caption mdn-Text--inverse">
              <strong>© 2021 Claro. Todos os direitos reservados.</strong>
            </p>
          </div>
          <div class="mdn-Footer-logo">
            <img class="mdn-Footer-logo-image" src="@/assets/logo-sgp-branco.svg" alt="">
          </div>
        </div>
      </div>
    </footer> -->
  </div>
</template>

<script>
import FormLoginComponent from "./FormLoginComponent.vue";

export default {
  name: "LoginPage",
  components: {
    FormLoginComponent,
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

header {
  background-color: $color-brand-primary-medium;
  padding: 20px 50px;
}

.btn-portal-header {
    font-size: 22px;
    font-weight: bold;
    color: #fff;
    padding: 5px 6px;
    margin: 0;
    border-radius: 50%;
    width: 50px;
}

.link-documentos-processos {
  text-decoration: none;
  color: #000;
}
</style>